module.exports = __webpack_public_path__ + "img/basket3.3d6fef1d.svg";